import { Injectable } from '@angular/core';
import { GenericService } from "../../commons/generic.service";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import {PlanoDeSaudeDependenteDto} from "../../components/recadastramento-aba11/plano-de-saude-dependente.dto";
import { TipoParentescoDto } from "../../model/tipoParentesco.dto";
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable({
  providedIn: 'root'
})
export class DependentesServidorAba11Service extends GenericService {

  private basePath = 'api/v1';
  private path = '/despesa-anual';
  url = environment.url;

  constructor(http: HttpClient) {
    super(http);
  }

  getDependentes(): Observable<any[]> {
    return this.http.get<any[]>(this.url + this.basePath + this.path + '/dependente/planos');
  }

  getPlanos(): Observable<PlanoDeSaudeDependenteDto[]> {
    return this.http.get<PlanoDeSaudeDependenteDto[]>(this.url + this.basePath + this.path + "/dependente/planos");
  }

  getMesesPlanoDependentes(plano: number, numeroDependente: number): Observable<any[]> {
    return this.http.get<any[]>(this.url + this.basePath + this.path + `/dependente/concessoes/${plano}/${numeroDependente}`);
  }

  getTipoParentescos(): Observable<TipoParentescoDto[]> {
    return this.http.get<TipoParentescoDto[]>(this.url + this.basePath + '/parentesco/obter-grau-parentesco');
  }

  getArquivos(idRecadDependente: string, tipo: string): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + '/dependentes-visualizar/' + tipo + '/' + idRecadDependente, options);
  }

  uploadComprovante(file: File, numeDependente: string, tipoDocumento: string) {
    const formData = new FormData();
    formData.append('documento', file);
    formData.append('numeDependente', numeDependente);

    return this.postMethodFile(this.basePath + '/dependentes-upload/' + tipoDocumento, formData);
  }
  enviarComprovanteEMes(arquivo: File, mesesSelecionados: number[], flTodos: boolean, numeroDoDependente: number, nome: string, valor: number, codigoPlano: number): Observable<any> {
    const auxilioSaude = {
      meses: mesesSelecionados,
      valor: valor,
      flTodos: flTodos,
      codigoPlano: codigoPlano,
      nomeDependente: nome,
      numeroDependente: numeroDoDependente,
    };
    const formData = new FormData();
    formData.append('file', arquivo);
    formData.append('auxilioSaude', JSON.stringify(auxilioSaude));

    return this.patchMethodFile(this.url + this.basePath + '/upload_comprovante/despesa-anual-dependente', formData);
  }

  visualizarComprovanteMes(plano:number, numeroDependente: number, mes: number): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };
    
    return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + `/visualizar_comprovante/despesa-anual/dependente/${plano}/${mes}/${numeroDependente}`, options);
  }

  deletarComprovante(plano:number, numeroDependente: number, mes: number): Observable<ArquivoBlobDTO> {
    

    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.put<ArquivoBlobDTO>(this.url + this.basePath + `/comprovante-deletar/despesa-anual/dependente/${plano}/${mes}/${numeroDependente}`, options);
  }
 
}
